import React from 'react';
import styled from 'styled-components';
import preleadCategoryColor from 'helpers/preleadCategoryColor';
import preleadColor from 'helpers/preleadColor';
import {Prelead, useCurrentClientQuery} from 'api';
import {Row} from 'react-table';

interface Props {
  row: Row<Prelead>;
}

const StatusCell = ({row}: Props) => {
  const prelead: Prelead = row.original;
  const {data: {currentClient: {preleadStatuses = []} = {}} = {}} =
    useCurrentClientQuery({
      fetchPolicy: 'cache-only',
    });
  const preleadStatus = preleadStatuses.find(
    (preleadStatus) => preleadStatus.id === prelead.clientPreleadStatusId,
  );

  const color = preleadStatus
    ? preleadCategoryColor(preleadStatus.category)
    : preleadColor(prelead.status);

  return <StatusMark color={color} />;
};

const StatusMark = styled.span<{color: string}>`
  display: inline-block;
  vertical-align: middle;
  height: 16px;
  width: 16px;
  border-radius: 4px;
  background-color: ${({color}) => color};
  margin-right: 5px;
  ${({color}) => !color && 'border: 1px solid var(--text-color-3)'};
`;

export default StatusCell;
